import axios from 'axios'
import { Dispatch, SetStateAction } from 'react'
import 'regenerator-runtime/runtime'

class Postier {
    async getAllClients(token: string, setClients, userid: number, setErrors: Dispatch<SetStateAction<string[]>>) {
        axios.get(`api-v0/clients/${userid}`,{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                setClients(res.data)
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "La liste des clients ne peut pas être récupérée"])
            localStorage.clear()
            // location.reload()
        })

    }

    async getSites(token:string,client:string,setSites, setErrors: Dispatch<SetStateAction<string[]>>){
        axios.get(`api-v0/sites/${client}`,{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                // console.log(res.data)
                setSites(res.data)
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, `La liste des sites du client: ${client} ne peut pas être récupérée`])
            localStorage.clear()
            // location.reload()
        })

    }

    getHoraires(token:string,site:string,setHoraires, setErrors: Dispatch<SetStateAction<string[]>>){
        axios.get(`api-v0/${site}/horaires`,{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                setHoraires(res.data)
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "les horaires ne peuvent pas être récupéré"])
            localStorage.clear()
            // location.reload()
        })

    }


}

export const postier = new Postier()